import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { GENERATE_QR_CODE, GENERATE_QR_CODE_FAIL, GENERATE_QR_CODE_SUCCESS } from 'actions/generateQrCode';

function* getQrCode(action) {
  try {
    const response = yield call(API.getQrCode, action.payload);
    yield put({ type: GENERATE_QR_CODE_SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: GENERATE_QR_CODE_FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* generateQrCode() {
  yield takeLatest(GENERATE_QR_CODE, getQrCode);
}

export default generateQrCode;
